module.exports = __webpack_public_path__ + "img/gift-cards-1.0fc38a05.png";